import React from "react";
import "../Styles/WhyUs.css";
import WhyUsImage from "../assets/WHYus.svg";

const WhyUs = () => {
  return (
    <section className="why-us">
      <div className="container why-us-wrapper">
          <div className="why-us-image reveal-left">
          <img src={WhyUsImage} alt="Students learning together with a tutor" />
        </div>

        <div className="why-us-content reveal-right">
          <p className="eyebrow">Why families choose us</p>
          <h2 className="section-title">Built by top students. Designed for real progress.</h2>
          <p className="section-lead">
            We match your child with high-achieving university tutors who know the Alberta
            curriculum — and know how to make learning click.
          </p>

          <ul className="why-list">
            <li>
              <span className="why-marker" aria-hidden="true"></span>
              <div>
                <h3>Top 1% peer tutors</h3>
                <p>
                  Our team is made of strong university students who recently mastered the same
                  material — approachable, sharp, and easy to learn from.
                </p>
              </div>
            </li>
            <li>
              <span className="why-marker" aria-hidden="true"></span>
              <div>
                <h3>Personal matching</h3>
                <p>
                  We pair students based on subject needs, personality, and learning style so
                  sessions feel comfortable from day one.
                </p>
              </div>
            </li>
            <li>
              <span className="why-marker" aria-hidden="true"></span>
              <div>
                <h3>Skills that outlast the semester</h3>
                <p>
                  Beyond homework help, we teach study habits, problem-solving, and how to learn
                  independently.
                </p>
              </div>
            </li>
            <li>
              <span className="why-marker" aria-hidden="true"></span>
              <div>
                <h3>Accessible pricing</h3>
                <p>
                  Because our tutors are exceptional students — not a large agency — families get
                  premium support at a more approachable rate.
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
